import { render } from "./PaginatorComponent.vue?vue&type=template&id=39250e36"
import script from "./PaginatorComponent.vue?vue&type=script&lang=js"
export * from "./PaginatorComponent.vue?vue&type=script&lang=js"

import "./PaginatorComponent.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__